// extracted by mini-css-extract-plugin
export default {"root":"SavedLabels_root__gqXD3","header":"SavedLabels_header__ynoEF","actions":"SavedLabels_actions__cR7rG"};